<script lang="ts">
    // whatever?
</script>
<div id="helpful-tips">
  <!-- <div class="newSection"> -->

    <h3 style="text-align: center;">Helpful Tips</h3>
    <ol class="list helpful-tips" type="1">
      <li>
        AI detectors may display <span class="spellcheck-underline">red underlines</span> beneath certain words. To
        remove them, simply retype each affected word.
      </li>
      <li>
        Once cloaked or uncloaked, your text will automatically be copied to
        your clipboard!
      </li>
      <li>
        TextCloaker for IOS and Android is in the works! Stay tuned for
        updates.
      </li>
    </ol>
  <!-- </div> -->
</div>

  <!-- demo vid from youtube -->
  <!-- <h3>Demo Video</h3>
  <div class="video-container">
    <iframe
      title="TextCloaker Demo Video"
      width="560"
      height="315"
      src="https://www.youtube.com/embed/9D6mXNf4fWI"
      frameborder="0"
      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>

  <div class="border-bottom" /> -->
  <!-- <div class="newSection"> -->

  <div>
  <h3 style="text-align: center;">Coming Soon</h3>
  <ol class="list helpful-tips" type="1">
    <li>
      Exciting news! TextCloaker will soon be available for iOS and Android.
      Stay tuned for more updates.
    </li>
    <li>
      Updates are currently in development to address bypassing human
      moderators (as well as AI moderators, of course).
    </li>
    <li>
      Synonym and Paraphrasing functionality currently in beta (courtesy of
      Savar S.)!
    </li>
  </ol>
  </div>
<!-- </div> -->

<style>
  .spellcheck-underline {
  text-decoration: underline wavy red;
}
</style>